import ComponentNavigation from "@organisms/ComponentNavigation/ComponentNavigation"

import { StepStackItemContentProps } from "./StepStackItemContent.types"

export default function StepStackItemContent({ id, children, className }: StepStackItemContentProps) {
    return (
        <ComponentNavigation.Component componentId={id} className={className}>
            {children}
        </ComponentNavigation.Component>
    )
}
